import { PartLite, PartLiteTypes } from '@luminovo/api-contracts';
import { uniqBy } from '@luminovo/commons';

/** By default one level of matches deep, unique by id and without the part itself. */
export function flattenPartLite(
    part: PartLite,
    options?: { flattenAllLevels?: boolean; unique?: boolean; includeSelf?: boolean },
): PartLite[] {
    const { flattenAllLevels = false, unique = true, includeSelf = false } = options ?? {};
    const flattenMatches = (matches: PartLite[]): PartLite[] =>
        flattenAllLevels ? matches.flatMap((match) => flattenPartLite(match, options)) : matches;

    let result: PartLite[];
    switch (part.kind) {
        case PartLiteTypes.OffTheShelf:
        case PartLiteTypes.Custom:
        case PartLiteTypes.RawSpecification:
        case PartLiteTypes.Unknown:
            result = [part];
            break;
        case PartLiteTypes.Generic:
            result = [...flattenMatches(part.matches)];
            break;
        case PartLiteTypes.Ipn:
            result = [...flattenMatches(part.matches)];
            break;
        case PartLiteTypes.CustomComponent:
            result = [...flattenMatches(part.parts)];
            break;
    }

    if (includeSelf) {
        result = [part, ...result];
    }

    return unique ? uniqBy(result, 'id') : result;
}
